export default __webpack_public_path__ + "static/media/logout.25ba6684.svg";